import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadGA, trackPageView } from "../lib/analytics";

export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => { loadGA(); }, []);
  useEffect(() => {
    // defer so document.title is updated by the destination page first
    const id = setTimeout(trackPageView, 350);
    return () => clearTimeout(id);
  }, [location.pathname]);
  return null;
}
